<div class="wk-av">
    <div class="wk-av--flex">
        <div
            class="wk-av__tab-navigation-wrapper"
            [class.wk-av__tab-navigation-wrapper--collapsed]="!firstColumnVisible"
            [class.wk-av__tab-navigation-wrapper--opened]="firstColumnVisible"
        >
            <div class="wk-av__scroll-content fancy-scrollbar-newUI">
                <!-- Display filters title -->
                @if (firstColumnVisible) {
                    <div class="wk-av__section-header">
                        {{ "AssigneesView.DisplayFilters" | translate }}
                    </div>
                }

                <!-- Steps display -->
                <div class="row wk-av__tab-navigation">
                    @if (firstColumnVisible) {
                        <div class="wk-av__tab-navigation--title">{{ "AssigneesView.Steps" | translate }}</div>
                    }
                    @if (firstColumnVisible) {
                        <div class="wk-av__tab-navigation--details fancy-scrollbar-newUI">
                            @for (step of steps; track step; let i = $index) {
                                <div class="column">
                                    <radio-field-pds3
                                        [labelFor]="'assignee_step_' + step.Id"
                                        [label]="step.Name | wkTranslate"
                                        [size]="'extra-small'"
                                    >
                                        <input
                                            [id]="'assignee_step_' + step.Id"
                                            [checked]="selectedStepId === step.Id"
                                            type="radio"
                                            name="step"
                                            (change)="updateStep(step.Id)"
                                            [value]="step.Id"
                                            flow-id="radio"
                                        />
                                    </radio-field-pds3>
                                </div>
                            }
                        </div>
                    }
                </div>
                <!-- Statuses display -->
                <div class="row wk-av__tab-navigation">
                    @if (firstColumnVisible) {
                        <div class="wk-av__tab-navigation--title wk-av__tab-navigation--padding-top">
                            @if (isJobsBillingDashboard()) {
                                {{ "AssigneesView.JobsBillingStatus" | translate }}
                            } @else {
                                {{ "AssigneesView.TaxprepStatus" | translate }}
                            }
                        </div>
                    }
                    @if (firstColumnVisible) {
                        <div class="wk-av__tab-navigation--details fancy-scrollbar-newUI">
                            @for (status of stepRelatedStatuses; track status; let i = $index) {
                                <div class="column">
                                    <radio-field-pds3
                                        [labelFor]="'assignee_taxreturnstatus_' + status?.TaxReturnStatus?.Id"
                                        [label]="status.TaxReturnStatus.Name | wkTranslate"
                                        [size]="'extra-small'"
                                    >
                                        <input
                                            [id]="'assignee_taxreturnstatus_' + status?.TaxReturnStatus?.Id"
                                            type="radio"
                                            name="status"
                                            [checked]="selectedStatus?.TaxReturnStatus?.Id === status?.TaxReturnStatus?.Id"
                                            [value]="status.TaxReturnStatus.Id"
                                            (change)="updateStatus(status.TaxReturnStatus.Id)"
                                        />
                                    </radio-field-pds3>
                                </div>
                            }
                        </div>
                    }
                </div>

                <!-- Column Filters Section -->
                @if (firstColumnVisible && isInitialized) {
                    <div class="wk-av__column-filters">
                        <div class="wk-av__column-filters--title">
                            <span>{{ "AssigneesView.UserFilters" | translate }}</span>
                            <div class="wk-av__dragdrop wk-av__column-filters--dragdrop">
                                @if (isDragDropDisabled()) {
                                    <icon-pds3 name="wk-icon-filled-caution" class="wk-av__icon__dragdrop" />
                                    <portal-pds3 elementId="wk-app__root">
                                        <tooltip-pds3
                                            mode="indicator"
                                            position="right"
                                            [openDelay]="400"
                                            [closeDelay]="50"
                                            targetSelector=".wk-av__column-filters--dragdrop .wk-av__icon__dragdrop"
                                        >
                                            <span
                                                [innerHTML]="
                                                    'AssigneesView.DragDropDisabledTooltip' | translate: { limit: VIRTUAL_SCROLL_THRESHOLD ?? 0 }
                                                "
                                            ></span>
                                        </tooltip-pds3>
                                    </portal-pds3>
                                }
                                <span
                                    >({{ displayedColumnsCount() }} {{ "AssigneesView.UsersVisible" | translate
                                    }}{{ displayedColumnsCount() > 1 ? "s" : "" }})</span
                                >
                            </div>
                        </div>

                        @if (isJobsBillingDashboard()) {
                            <div class="wk-av__column-filter wk-av__column-filter--padding-top">
                                <label class="wk-av__column-filter--label">
                                    {{ "AssigneesView.Roles" | translate }}
                                </label>
                                <kendo-multiselect-wrapper
                                    name="columnFilterRoles"
                                    [data]="filteredRolesOptions"
                                    textField="text"
                                    valueField="value"
                                    [valuePrimitive]="false"
                                    [(ngModel)]="selectedRoles"
                                    (ngModelChange)="onRolesSelectionChange($event)"
                                    (filterChange)="onRolesSearch($event)"
                                    placeholder="{{ 'AssigneesView.SelectAnOption' | translate }}"
                                    noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                    clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                                />
                            </div>
                        }

                        <!-- Users Filter -->
                        <div
                            class="wk-av__column-filter"
                            [class.wk-av__column-filter--padding-top]="!isJobsBillingDashboard()"
                            [class.wk-av__column-filter--padding-bottom]="!isGroup1Visible && !isGroup2Visible"
                        >
                            <label class="wk-av__column-filter--label">
                                {{ "AssigneesView.Users" | translate }}
                            </label>
                            <kendo-multiselect-wrapper
                                name="columnFilterUsers"
                                [data]="filteredUsersOptions"
                                textField="text"
                                valueField="value"
                                [valuePrimitive]="false"
                                [disabled]="isUsersDisabled"
                                [(ngModel)]="selectedUsers"
                                (ngModelChange)="onUsersSelectionChange($event)"
                                (filterChange)="onUsersSearch($event)"
                                placeholder="{{ 'AssigneesView.SelectAnOption' | translate }}"
                                noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                                [virtual]="true"
                            />
                        </div>

                        <!-- User Group 1 Filter -->
                        @if (isGroup1Visible) {
                            <div class="wk-av__column-filter" [class.wk-av__column-filter--padding-bottom]="!isGroup2Visible">
                                <label class="wk-av__column-filter--label">
                                    {{ group1Label || ("AssigneesView.UserGroup1" | translate) }}
                                </label>
                                <kendo-multiselect-wrapper
                                    name="columnFilterGroup1"
                                    [data]="filteredUserGroup1Options"
                                    textField="text"
                                    valueField="value"
                                    [valuePrimitive]="false"
                                    [disabled]="isGroupDisabled"
                                    [(ngModel)]="selectedUserGroup1"
                                    (ngModelChange)="onUserGroup1SelectionChange($event)"
                                    (filterChange)="onUserGroup1Search($event)"
                                    placeholder="{{ 'AssigneesView.SelectAnOption' | translate }}"
                                    noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                    clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                                />
                            </div>
                        }

                        <!-- User Group 2 Filter -->
                        @if (isGroup2Visible) {
                            <div class="wk-av__column-filter wk-av__column-filter--padding-bottom">
                                <label class="wk-av__column-filter--label">
                                    {{ group2Label || ("AssigneesView.UserGroup2" | translate) }}
                                </label>
                                <kendo-multiselect-wrapper
                                    name="columnFilterGroup2"
                                    [data]="filteredUserGroup2Options"
                                    textField="text"
                                    valueField="value"
                                    [valuePrimitive]="false"
                                    [disabled]="isGroupDisabled"
                                    [(ngModel)]="selectedUserGroup2"
                                    (ngModelChange)="onUserGroup2SelectionChange($event)"
                                    (filterChange)="onUserGroup2Search($event)"
                                    placeholder="{{ 'AssigneesView.SelectAnOption' | translate }}"
                                    noDataText="{{ 'FiltersSidebar.Options.MultiSelect.NoData' | translate }}"
                                    clearTitleText="{{ 'FiltersSidebar.Options.MultiSelect.ClearTitle' | translate }}"
                                />
                            </div>
                        }
                    </div>
                }
            </div>

            <div class="wk-av__footer" [class.wk-av__footer--row]="firstColumnVisible" [class.wk-av__footer--column]="!firstColumnVisible">
                @if (isDragDropDisabled()) {
                    <div class="wk-av__dragdrop wk-av__footer--dragdrop">
                        <icon-pds3 name="wk-icon-filled-caution" class="wk-av__icon__dragdrop" />
                        <span>{{ "AssigneesView.DragDropDisabled" | translate }}</span>

                        <portal-pds3 elementId="wk-app__root">
                            <tooltip-pds3
                                mode="indicator"
                                position="right"
                                [openDelay]="400"
                                [closeDelay]="50"
                                targetSelector=".wk-av__footer--dragdrop .wk-av__icon__dragdrop"
                            >
                                <span
                                    [innerHTML]="'AssigneesView.DragDropDisabledTooltip' | translate: { limit: VIRTUAL_SCROLL_THRESHOLD ?? 0 }"
                                ></span>
                            </tooltip-pds3>
                        </portal-pds3>
                    </div>
                }
                <icon-pds3
                    [name]="`wk-icon-chevron-double-${firstColumnVisible ? 'left' : 'right'}`"
                    (click)="toggleFirstColumnWidth()"
                    class="wk-av__icon__toggle"
                />
            </div>
        </div>

        <div
            class="col-md-auto wk-av__columns-wrapper"
            [class.wk-av__columns-wrapper--opened]="firstColumnVisible && this.selectedStatus?.TaxReturnStatus"
            [class.wk-av__columns-wrapper--collapsed]="!firstColumnVisible && this.selectedStatus?.TaxReturnStatus"
            [class.wk-av__columns-wrapper--opened-invalid]="firstColumnVisible && !this.selectedStatus?.TaxReturnStatus"
            [class.wk-av__columns-wrapper--collapsed-invalid]="!firstColumnVisible && !this.selectedStatus?.TaxReturnStatus"
        >
            @if (isInitialized && !this.selectedStatus?.TaxReturnStatus) {
                <div class="wk-card-view__display-no-info">{{ "ViewComponent.NoInfo" | translate }}</div>
            }
            <!-- Columns display -->
            @if (this.selectedStatus?.TaxReturnStatus) {
                @if (isJobsBillingDashboard()) {
                    <jobs-assignees-columns-wrapper
                        [isInitialized]="isInitialized"
                        [selectedStatus]="selectedStatus"
                        [selectedStepId]="selectedStepId"
                        [columnFilters]="columnFilterSelection"
                    />
                } @else {
                    <assignees-columns-wrapper
                        [isInitialized]="isInitialized"
                        [selectedStatus]="selectedStatus"
                        [selectedStepId]="selectedStepId"
                        [columnFilters]="columnFilterSelection"
                    />
                }
            }
        </div>
    </div>
</div>
